import LayoutProvider from "../../../providers/LayoutProvider";
import "./Backup.scss";
import useFileDownload from "../../../hooks/useFileDownload";
import { useEffect, useState } from "react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { toast, ToastContainer } from "react-toastify";
import BackupLogsTable from "./BackupLogsTable";
import BackupService from "../../../services/backup.service";

function Backup() {

  const [loading, setLoading] = useState<boolean>(false)
  const [loadingRestore, setLoadingRestore] = useState<boolean>(false)
  const [file, setFile] = useState<File | null>(null)




  const [perPage, setPerPage] = useState(10)
  const [page, setPage] = useState(1)
  const [data, setData] = useState([])
  const [totalCount, setTotalCount] = useState(0)

  const handlePerRowsChange = async (newPerPage: number) => {
    setPerPage(newPerPage)
  }
  const handlePageChange = (page: number) => {
    setPage(page)
  }

  const getBackupLogs = async () => {
    const response: any = await BackupService.getBackupLogs();
    if (Array.isArray(response.data)) {
      setData(response.data)
      setTotalCount(response.totalCount)
    }
  }

  useEffect(() => {
    getBackupLogs()
  }, [page, perPage])


  const showToastMessage = (response: any) => {
    toast(
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ padding: "2px", marginRight: "8px" }}>
          <CheckCircleOutlineIcon />
        </div>
        <span>{response}</span>
      </div>,
      {
        position: "top-center",
        autoClose: 2000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        hideProgressBar: true,
        style: {
          textAlign: "center",
          color: "green",
          background: "#edf7ed",
          borderRadius: "8px",
          padding: "10px",
          fontWeight: "bold",
          borderBottom: "5px solid green",
        },
      }
    );

    //CheckCircleOutlineIcon
  };

  const showFailedToastMessage = (response: any) => {
    toast(
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ padding: "2px", marginRight: "8px" }}>
          <ErrorOutlineIcon />
        </div>
        <span>{response}</span>
      </div>,
      {
        position: "top-center",
        autoClose: 2000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        hideProgressBar: true,
        style: {
          textAlign: "center",
          marginRight: "25%",
          maxWidth: "fit-content",
          color: "#CC0000",
          background: "#fdeded",
          borderRadius: "8px",
          padding: "10px",
          fontWeight: "bold",
          borderBottom: "5px solid #CC0000",
        },
      }
    );
  };

  const downloadFile = useFileDownload()

  const downloadBackup = async (e: any) => {
    e.preventDefault()
    try {
      const backup_api_url = process.env.REACT_APP_API_PROTOCOL + "://" + process.env.REACT_APP_API_HOST + "/api/v1/backup"
      const password = window.prompt("Please enter your password")
      if (!password?.trim()) return
      setLoading(true)
      const res: any = await fetch(backup_api_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify({ password: password?.trim() })
      })
      if (!res.ok) {
        throw new Error('backup download failed ');
      }
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      downloadFile(url, "backup.zip")
      showToastMessage("Backup downloaded successfully")
      getBackupLogs()
    } catch (err: any) {
      showFailedToastMessage(err?.message);
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  const restoreBackup = async (e: any) => {
    e.preventDefault()
    console.log(file)
    if (!file) {
      showFailedToastMessage("Please select a file")
      return
    }
    try {
      const backup_api_url = process.env.REACT_APP_API_PROTOCOL + "://" + process.env.REACT_APP_API_HOST + "/api/v1/backup/restore"
      const password = window.prompt("Please enter your password")
      if (!password?.trim()) return
      const formData = new FormData();
      formData.append("backup", file);
      formData.append("password", password?.trim());
      setLoadingRestore(true)
      const res: any = await fetch(backup_api_url, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: formData
      })
      if (!res.ok) {
        throw new Error('backup restore failed ');
      }
      showToastMessage("Backup restored successfully")
      getBackupLogs()
      setFile(null)
    } catch (err: any) {
      showFailedToastMessage(err?.message);
      console.log(err)
    } finally {
      setLoadingRestore(false)
    }
  }
  return (
    <LayoutProvider>
      <ToastContainer />
      <section
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h4 className="dashboard_heading">Backup</h4>
        <h6 className="dashboard_subheading">Dashboard {">"} Backup</h6>
      </section>
      <div style={{ display: "flex", gap: "10px" }}>
        <div className="backup_top">
          <button className="button" onClick={downloadBackup} disabled={loading}>{loading ? <span>Please Wait...</span> : <span>Backup Now</span>}</button>
        </div>
        <span>OR</span>
        <div className="backup_top">
          <form style={{ display: "flex", gap: 10 }}>
            <input type="file" accept=".zip,.rar,.7zip" onChange={(e: any) => setFile(e.target.files[0])} />
            <button className="button" disabled={loadingRestore} onClick={restoreBackup}>{loadingRestore ? "Restoring..." : "Restore"}</button>
          </form>
        </div>
      </div>

      <div style={{ margin: "20px 0" }}>
        <BackupLogsTable data={data} totalCount={totalCount} handlePageChange={handlePageChange} handlePerRowsChange={handlePerRowsChange} />
      </div>
    </LayoutProvider >
  );
}

export default Backup;
